export const deg2rad = (deg) => (deg * Math.PI) / 180.0;
export const rad2deg = (rad) => (rad * 180) / Math.PI;

export const geolocationCalcDistFromUserLocation = (destination, userLoc) => {
  const theta = destination.lon - userLoc.lon;
  let dist = Math.sin(deg2rad(destination.lat)) * Math.sin(deg2rad(userLoc.lat)) + Math.cos(deg2rad(destination.lat)) * Math.cos(deg2rad(userLoc.lat)) * Math.cos(deg2rad(theta));
  dist = Math.acos(dist);
  dist = rad2deg(dist);
  const miles = dist * 60 * 1.1515;

  dist = miles * 1.609344;
  return dist;
};
